var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 32.9062V17.0625H7.125V32.9062C7.125 33.2295 7.25011 33.5395 7.47281 33.768C7.69551 33.9966 7.99756 34.125 8.3125 34.125H29.6875C30.0024 34.125 30.3045 33.9966 30.5272 33.768C30.7499 33.5395 30.875 33.2295 30.875 32.9062V17.0625H33.25V32.9062C33.25 33.8759 32.8747 34.8059 32.2066 35.4916C31.5385 36.1773 30.6323 36.5625 29.6875 36.5625H8.3125C7.36767 36.5625 6.46153 36.1773 5.79343 35.4916C5.12533 34.8059 4.75 33.8759 4.75 32.9062ZM30.875 6.09375V14.625L26.125 9.75V6.09375C26.125 5.77052 26.2501 5.46052 26.4728 5.23196C26.6955 5.0034 26.9976 4.875 27.3125 4.875H29.6875C30.0024 4.875 30.3045 5.0034 30.5272 5.23196C30.7499 5.46052 30.875 5.77052 30.875 6.09375Z",
    fill: "#280948"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3209 3.65629C17.7662 3.19933 18.3702 2.94263 19 2.94263C19.6297 2.94263 20.2337 3.19933 20.6791 3.65629L36.4657 19.8559C36.6887 20.0848 36.814 20.3952 36.814 20.7188C36.814 21.0424 36.6887 21.3528 36.4657 21.5817C36.2427 21.8105 35.9403 21.9391 35.625 21.9391C35.3096 21.9391 35.0072 21.8105 34.7842 21.5817L19 5.37961L3.21572 21.5817C2.99274 21.8105 2.69032 21.9391 2.37497 21.9391C2.05963 21.9391 1.75721 21.8105 1.53422 21.5817C1.31124 21.3528 1.18597 21.0424 1.18597 20.7188C1.18597 20.3952 1.31124 20.0848 1.53422 19.8559L17.3209 3.65629Z",
    fill: "#280948"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.92868467546ce1d03b0ca58a6ab590f9.svg";
export { ForwardRef as ReactComponent };